<template>
  <el-dropdown
    ref="down"
  >
    <i
      class="iconfont icon-gengduo pointer three-point"
    ></i>
    <el-dropdown-menu
      slot="dropdown">
      <el-dropdown-item
        v-if="!isDemo && accountInfo.businessType !== 6"

      >
        <div class="btn-text"
             @click="transferHandle"
        >{{$t('User.transferAccounts')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
        v-if="!isDemo && accountInfo.businessType !== 6"
      >
        <div class="btn-text"
             @click="leverHandle"
        >{{$t('User.leverSet')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
      >
        <div class="btn-text"
             @click="passwordHandle"
        >{{$t('User.passSet')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
        v-if="accountSettingFlag"
      >
        <div class="btn-text"
             @click="accountTypeSetHandle"
        >{{$t('customerHome.Account_type_settings')}}</div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "accountOperate",
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    },
    accountInfo:{
      type: Object,
      default(){
        return {
          accountInfo: '',
        }
      }
    }
  },
  computed: {
    accountSettingFlag() {
      return !this.isDemo && this.accountInfo.businessType !== 6 && this.accountInfo.businessType !== 1 && this.accountInfo.currency != 'USC';
    }
  },
  methods: {
    transferHandle() {
      this.$emit('transferHandle');
      this.$refs.down.hide();
    },
    leverHandle(){
      this.$emit('leverHandle');
      this.$refs.down.hide();
    },
    passwordHandle(){
      this.$emit('passwordHandle');
      this.$refs.down.hide();
    },
    accountTypeSetHandle(){
      this.$emit('accountTypeSetHandle');
      this.$refs.down.hide();
    },
  },
}
</script>

<style lang="scss" scoped>
.three-point {
  font-size: 16px;
  padding: 10px;
  padding-right: 5px;
}

</style>
